import { render, staticRenderFns } from "./VueReadmore.vue?vue&type=template&id=01cee7fc&scoped=true&"
import script from "./VueReadmore.vue?vue&type=script&lang=js&"
export * from "./VueReadmore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cee7fc",
  null
  
)

export default component.exports